import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { useGetUserByIdQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'LockInfoTooltip',
  props: {
    lockedByUserId: null,
    lockedReason: null,
    lockLevel: null,
    maxWidth: {
      default: 420
    },
    iconColor: {
      default: 'error'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var isLoading = ref(false);
    var resolvedName = ref('');
    var userByIdVariables = ref({
      id: ''
    });
    var _useGetUserByIdQuery = useGetUserByIdQuery(userByIdVariables, {
        enabled: false,
        fetchPolicy: 'network-only'
      }),
      refetchUserById = _useGetUserByIdQuery.refetch;
    var normalizedUserId = computed(function () {
      if (!props.lockedByUserId) return null;
      var id = String(props.lockedByUserId).trim();
      return id || null;
    });
    var fallbackLockerLabel = computed(function () {
      if (props.lockLevel === 'IX_ADMIN') return proxy.$t('impactNexusAdmin');
      if (props.lockLevel === 'PORTFOLIO') return proxy.$t('portfolioManager');
      return proxy.$t('unknownUser');
    });
    var tooltipText = computed(function () {
      var _props$lockedReason;
      var reason = (_props$lockedReason = props.lockedReason) === null || _props$lockedReason === void 0 ? void 0 : _props$lockedReason.trim();
      var lockedByText = resolvedName.value ? "".concat(proxy.$t('lockedBy'), " ").concat(resolvedName.value, ". ") : normalizedUserId.value ? "".concat(proxy.$t('lockedBy'), " ").concat(fallbackLockerLabel.value, ". ") : '';
      if (reason) return "".concat(lockedByText).concat(proxy.$t('reason'), ": ").concat(reason);
      if (lockedByText) return lockedByText;
      return String(proxy.$t('lockedNoReason'));
    });
    var onHover = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _data$getUserById, _data$getUserById$fir, _data$getUserById2, _data$getUserById2$la, response, data, first, last, fullName;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!normalizedUserId.value || resolvedName.value || isLoading.value)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              isLoading.value = true;
              _context.prev = 3;
              _context.next = 6;
              return refetchUserById({
                id: normalizedUserId.value
              });
            case 6:
              response = _context.sent;
              data = response === null || response === void 0 ? void 0 : response.data;
              first = (data === null || data === void 0 ? void 0 : (_data$getUserById = data.getUserById) === null || _data$getUserById === void 0 ? void 0 : (_data$getUserById$fir = _data$getUserById.firstName) === null || _data$getUserById$fir === void 0 ? void 0 : _data$getUserById$fir.trim()) || '';
              last = (data === null || data === void 0 ? void 0 : (_data$getUserById2 = data.getUserById) === null || _data$getUserById2 === void 0 ? void 0 : (_data$getUserById2$la = _data$getUserById2.lastName) === null || _data$getUserById2$la === void 0 ? void 0 : _data$getUserById2$la.trim()) || '';
              fullName = [first, last].filter(Boolean).join(' ').trim();
              if (fullName) resolvedName.value = fullName;
            case 12:
              _context.prev = 12;
              isLoading.value = false;
              return _context.finish(12);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3,, 12, 15]]);
      }));
      return function onHover() {
        return _ref2.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      proxy: proxy,
      isLoading: isLoading,
      resolvedName: resolvedName,
      userByIdVariables: userByIdVariables,
      refetchUserById: refetchUserById,
      normalizedUserId: normalizedUserId,
      fallbackLockerLabel: fallbackLockerLabel,
      tooltipText: tooltipText,
      onHover: onHover
    };
  }
});